export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_USER_BY_TOKEN = "LOGIN_USER_BY_TOKEN"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_UPDATE = "LOGIN_UPDATE"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"

export const API_ERROR = "LOGIN_API_ERROR"
